// Server base URL - your backend API
//export const BASE_URL = process.env.REACT_APP_API_URL || "http://20.83.155.145:3001/api";
export const BASE_URL = process.env.REACT_APP_API_URL || "https://lala-app.think-straight.com/api";
//export const MEDIA_URL = "http://20.83.155.145/PROJECTS/hoteltz-backend";
export const MEDIA_URL = "https://lala-app.think-straight.com/";
// Alias for backward compatibility
export const API_BASE_URL = BASE_URL;


// Server base URL - your backend API
// export const BASE_URL = process.env.REACT_APP_API_URL || "http://20.83.155.145:3001/api";
// export const BASE_URL = process.env.REACT_APP_API_URL || "https://lala-app.think-straight.com/api";

// export const MEDIA_URL = "https://lala-app.think-straight.com/";
// Alias for backward compatibility
// export const API_BASE_URL = BASE_URL;
